import FontBody1 from "../../../../../components/fonts/font-body1/font-body1";
import { FONT_COLOR, FONT_VARIANT } from "../../../../../components/fonts/font-props";
import { PlanStore } from "../../../../subscription-plans/stores/subscription-plans-store";
import OnboardingPlanShortDescription from "../onboarding-plan-short-description/onboarding-plan-short-description";
import "./onboarding-coverage-plan-header.scss";
import OnboardingPlanPricing from "./onboarding-plan-pricing";

interface IProps {
    plan: PlanStore;
}

const OnboardingCoveragePlanHeader: React.FC<IProps> = (({plan}) => {
    
    return (
        <div className="onboarding-coverage-plan-header">
            <div>
                <div className="onboarding-coverage-plan-header-title">
                    <FontBody1 color={FONT_COLOR.NEUTRAL_WHITE} variant={FONT_VARIANT.BOLD}>{"Return Guard"}</FontBody1>
                </div>
                <div className="onboarding-coverage-plan-header-short-description">
                    <OnboardingPlanShortDescription plan={plan}/>
                </div>
                <div className="onboarding-coverage-plan-header-pricing-title">
                    <OnboardingPlanPricing plan={plan} isCoveragePlan={true}    />
                </div>
            </div>
        </div>
    );
});

export default OnboardingCoveragePlanHeader;
